import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import { analyticsReady } from './config/firebase'
import AnalyticsService from './services/AnalyticsService'
import App from './App.jsx'

analyticsReady.then(() => AnalyticsService.markReady())

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
